import { forwardRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as S from './styled/Icon.styled';

/**
 * @author Burak Unsal
 * @description Icon component for the application.
 * @param {Object} props - props of the component.
 * @param {Object} [props.icon] - You can use any icon from FontAwesome.
 * @param {string} [props.kitName] - You can use any icon name from FontAwesome Kit.
 * @param {'x-small' | 'small' | 'medium' | 'large' | 'x-large' | 'xx-large' | 'xxx-large'} [props.size = 'small'] - The size of the component.
 * @param {string} [props.fontSize] - The font size of the component.
 * @param {string} [props.color = 'var(--black)'] - The color of the icon.
 * @param {Object} [props.style] - Adds css to the styled component. Override or extend the styles applied to the component.
 * @param {string} [props.className] - Adds classname to the component. Override or extend the styles applied to the component.
 * @param {Object} [props.children] - Adds children to the component.
 * @returns {React.Component} - Returns the component.
 * @example
 * <Icon icon={faUser} size="large" />
 * <Icon kitName="fa-thin-user-circle-question" size="x-large" />
 */
const Icon = (props, ref) => {
	const { icon, kitName, size = 'small', fontSize, style, className, color = 'var(--black)', ...moreProps } = props;

	return (
		<S.Wrapper
			ref={ref}
			style={style}
			fontSize={fontSize}
			color={color}
			className={`icon ${size} ${className ?? ''}`}>
			{icon ? <FontAwesomeIcon icon={icon} fixedWidth {...moreProps} /> : <i className={`fak ${kitName}`} />}
			{props.children}
		</S.Wrapper>
	);
};

export default forwardRef(Icon);
